import React from 'react';
import { Button } from 'antd';
import WarningTips from 'components/WarningTips';
import s from './s.module.less';

type IProps = {
    isShow?: boolean;
    onOptIn?: () => void;
};

const OptOutWarning: React.FC<IProps> = (props) => {
    const { isShow = true, onOptIn } = props;

    if (!isShow) {
        return null;
    }

    return (
        <div className={s.wrap}>
            <WarningTips
                title="You've opted out of patient reviews"
                description="You're currently not collecting reviews from patients. Patient reviews help build trust, highlight your quality of care, and attract new patients. Opt in to start collecting feedback from your patients."
                isShow={isShow}
            />
            <Button
                className={s.optInButton}
                type="primary"
                onClick={() => {
                    onOptIn?.();
                }}
            >
                Opt in now
            </Button>
        </div>
    );
};

export default OptOutWarning;
